import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Stack } from '@mui/material';

import * as routes from 'router/routes';
import Footer from 'components/complex/Footer';
import { Link } from 'components/simple';

const styles = {
  footerWrapper: ({ breakpoints }) => ({
    alignItems: 'center',
    alignSelf: 'center',
    marginTop: 6,
    [breakpoints.up('lg')]: {
      marginTop: 12,
    },
    [breakpoints.up('xl')]: {
      marginTop: 2,
    },
    [breakpoints.up('xxl')]: {
      alignItems: 'flex-start',
      alignSelf: 'flex-start',
      marginTop: 4,
    },
  }),
};

const PrivacyPolicyFooter = ({ customStyles = null }) => {
  return (
    <Stack gap={2} sx={[styles.footerWrapper, customStyles]}>
      <Link to={routes.privacyPolicy} target="_blank" rel="noreferrer" component={RouterLink}>
        Privacy Policy
      </Link>

      <Footer />
    </Stack>
  );
};

PrivacyPolicyFooter.propTypes = {
  customStyles: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
};
export default PrivacyPolicyFooter;
